// custom typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'
import './src/main.css'

export { default as wrapRootElement } from './src/redux/ReduxWrapper'